export default __webpack_public_path__ + "static/dreamers-team-logo-3f6abb8e22ac4b40948089be8fd33e4a.png";